export function waitForImages(element) {
  if (!element) {
    return Promise.resolve();
  }

  const images = [...element.querySelectorAll("img")];

  return Promise.all(
    images.map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete && img.naturalHeight !== 0) {
            resolve();
            return;
          }

          const finish = () => resolve();
          img.addEventListener("load", finish, { once: true });
          img.addEventListener("error", finish, { once: true });
        })
    )
  );
}
